import React from "react";

const Footer = () => {
  return (
    <footer className="relative pt-16 pb-10 px-6 border-t border-panel/5" data-testid="footer">
      <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <a href="#top" className="flex items-center gap-3">
            <span className="w-2.5 h-2.5 rounded-full bg-aura-cyan shadow-[0_0_12px_rgb(var(--accent-cyan-rgb)/0.9)]" />
            <span className="font-display text-[22px] tracking-[-0.02em] text-ink font-light">AURA<span className="text-aura-cyan">.</span></span>
          </a>
          <p className="mt-4 text-whisper text-[14px] leading-[1.6] max-w-sm">
            Immersive language intelligence. One continuous conversation — not a sequence of resets.
          </p>
        </div>
        <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-4 gap-6 font-mono text-[10.5px] tracking-[0.22em] uppercase text-whisper-muted">
          <div>
            <div className="text-ink/80 mb-3">Product</div>
            <a className="block py-1 hover:text-ink" href="#memory">Memory</a>
            <a className="block py-1 hover:text-ink" href="#voice">Voice</a>
            <a className="block py-1 hover:text-ink" href="#graph">Graph</a>
            <a className="block py-1 hover:text-ink" href="#demo">Demo</a>
          </div>
          <div>
            <div className="text-ink/80 mb-3">Company</div>
            <a className="block py-1 hover:text-ink" href="#waitlist">Waitlist</a>
            <a className="block py-1 hover:text-ink" href="#pricing">Pricing</a>
            <a className="block py-1 hover:text-ink" href="#top">Manifesto</a>
          </div>
          <div>
            <div className="text-ink/80 mb-3">Resources</div>
            <a className="block py-1 hover:text-ink" href="#top">CEFR Guide</a>
            <a className="block py-1 hover:text-ink" href="#top">Changelog</a>
            <a className="block py-1 hover:text-ink" href="#top">Research</a>
          </div>
          <div>
            <div className="text-ink/80 mb-3">Legal</div>
            <a className="block py-1 hover:text-ink" href="#top">Privacy</a>
            <a className="block py-1 hover:text-ink" href="#top">Terms</a>
            <a className="block py-1 hover:text-ink" href="#top">Voice data</a>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-panel/5 flex flex-wrap items-center justify-between gap-3 font-mono text-[10.5px] tracking-[0.22em] uppercase text-whisper-muted">
        <span>© {new Date().getFullYear()} AURA Intelligence · All rights remembered.</span>
        <span>Made for ambitious voices</span>
      </div>
    </footer>
  );
};

export default Footer;
